import { Grid, Select, SelectChangeEvent, MenuItem, TextField } from '@mui/material';
import daysjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { ChangeEvent, useState } from 'react';

import { getMonthList } from '../features/submissions/submissionListing/helper/menuList';

interface IFieldValue {
  year: number | null;
  month: string | null;
}

const MonthAndYearField = ({
  initialValue,
  onInputChange,
}: {
  initialValue: string | null;
  onInputChange(args: string): void;
}) => {
  console.log(initialValue);
  const months = getMonthList;
  const [value, setValue] = useState<IFieldValue>({
    year:
      !isEmpty(initialValue) && initialValue ? parseInt(daysjs(initialValue).format('YYYY')) : null,
    month: !isEmpty(initialValue) && initialValue ? daysjs(initialValue).format('M') : null,
  });

  const handleDateChange = (e, interval: string) => {
    const tempDate = { ...value };
    if (interval === 'month') {
      console.log(e.target.value);
      tempDate.month = e.target.value as string;
    } else if (interval === 'year') {
      tempDate.year = parseInt(e.target.value as string);
    }
    setValue(tempDate);
    if (tempDate.month && tempDate.year) {
      const dob = `1/${months[tempDate.month].month}/${tempDate.year}`;
      onInputChange(new Date(dob).toString());
    }
  };

  return (
    <Grid item xs={12}>
      <Select
        sx={{ height: '47px', minWidth: '126px' }}
        placeholder="month"
        onChange={(event: SelectChangeEvent<unknown>) => handleDateChange(event, 'month')}
        value={value.month ?? ''}
      >
        {months.map((obj, index: number) => (
          <MenuItem key={index} value={obj.index}>
            {obj.month}
          </MenuItem>
        ))}
      </Select>
      <TextField
        sx={{ ml: 2, width: '45%' }}
        value={value.year}
        inputProps={{ style: { padding: '11.5px 14px' } }}
        placeholder="year"
        variant="outlined"
        type="number"
        onChange={(event: ChangeEvent<unknown>) => handleDateChange(event, 'year')}
        autoComplete="candidate_exp_year"
      />
    </Grid>
  );
};

export default MonthAndYearField;
